import { useEffect, useRef } from 'react';
import { useProjects } from '@/contexts/ProjectsContext';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export function useProjectCountTracking() {
  const { activeProjects, archivedProjects } = useProjects();
  const { user } = useAuth();
  const lastCountRef = useRef<number>(0);

  useEffect(() => {
    if (!user) return;

    const totalProjects = activeProjects.length + archivedProjects.length;
    
    // Only track if the count has changed
    if (totalProjects !== lastCountRef.current) {
      const previousCount = lastCountRef.current;
      lastCountRef.current = totalProjects;

      // Save the new project count to the usage database
      const saveProjectCount = async () => {
        try {
          const { error } = await supabase.rpc('increment_usage', {
            user_uuid: user.id,
            metric_type_param: 'projects_count',
            increment_amount: totalProjects - previousCount // This will be the difference
          });
          
          if (error) {
            console.warn('Failed to track project count change:', error);
          }
        } catch (error) {
          console.warn('Error tracking project count:', error);
        }
      };

      saveProjectCount();
    }
  }, [activeProjects.length, archivedProjects.length, user]);
}
